import { Star, ShieldCheck, Heart, Leaf } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export default function TrustBand() {
  const { lang } = useLanguage();
  const items =
    lang === "es"
      ? [
          { icon: Star, label: "4.7★ en Google", sub: "97+ reseñas" },
          { icon: ShieldCheck, label: "Cancelación gratis", sub: "Hasta 24h antes" },
          { icon: Heart, label: "Familiar", sub: "Negocio local desde 2019" },
          { icon: Leaf, label: "Eco-consciente", sub: "Grupos pequeños · sin huella" },
        ]
      : [
          { icon: Star, label: "4.7★ on Google", sub: "97+ reviews" },
          { icon: ShieldCheck, label: "Free cancellation", sub: "Up to 24h ahead" },
          { icon: Heart, label: "Family-run", sub: "Local since 2019" },
          { icon: Leaf, label: "Eco-conscious", sub: "Small groups · zero trace" },
        ];

  return (
    <section
      className="border-y border-[#E5DACC] bg-white"
      data-testid="trust-band"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-px overflow-hidden bg-[#E5DACC] md:grid-cols-4">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <div
              key={it.label}
              className="flex items-center gap-3 bg-white px-5 py-5 md:px-8 md:py-7"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#FF5533]/10 text-[#FF5533]">
                <Icon size={18} strokeWidth={1.75} />
              </div>
              <div className="leading-tight">
                <div
                  className="text-sm font-semibold text-[#0A0A0A] md:text-[15px]"
                  style={{ fontFamily: "Manrope, sans-serif" }}
                >
                  {it.label}
                </div>
                <div className="text-[11px] uppercase tracking-wider text-[#4A4A4A] md:text-xs">
                  {it.sub}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
